export class VehicleMaster {
    public VEH_ID!: number;
    public VEH_NO!: string;
    public OWNER_NAME!: string;
    public ADD1!: string;
    public Add2!: string;
    public PHONE_NO!: string;
    public DRIVER_NAME!: string;
    public LICENCE_NO!: string;
    public AUTHORITY!: string;
    public INS_NO!: string;
    public VALID_UPTO!: string;
    public VEH_MAKE!: string;
    public ENGINE_NO!: string;
    public CHASIS_NO!: string;
    public VEH_PUBLISH!: number;
    public ADV_AC!: string;
    public MNTN_AC!: string;
    public DIESEL_EXP_AC!: string;
    public TOLL_EXP_AC!: string;
    public OTH_EXP_AC!: string;
    public VEH_LOC!: string;
    public BAL_AC!: string;
    public RTO_EXP_AC!: string;
    public PS_EXP_AC!: string;
    public PIC_AC!: string;
    public OUT_AC!: string;
    public CREATEDBY_USERID!: Number;
    public UPDATEDBY_USERID!: Number;
    public CREATED_DATE!: Date;
    public UPDATED_DATE!: Date;
    public IS_ACTIVE!: boolean;
}